<div class="container container-narrow" *ngIf="model$ | async as model">
    <div class="loader-container">
        <h2>Create your account to continue</h2>

        <p>Already have an account? Login <a href={{loginUrl}}>here</a> to continue.</p>

        <form id="MainForm" #mainForm="ngForm" (ngSubmit)="submit(mainForm)" novalidate>
            <div class="form-field">
                <label for="firstNameId">First name</label>
                <input id="firstNameId" [(ngModel)]="model.FirstName" name="firstName" required maxlength="100" #firstNameCtrl="ngModel">
                <div class="error-message" *ngIf="firstNameCtrl.invalid && firstNameCtrl.touched">
                    First name is required.
                </div>
            </div>
            <div class="form-field">
                <label for="lastNameId">Last name</label>
                <input id="lastNameId" [(ngModel)]="model.LastName" name="lastName" required maxlength="100" #lastNameCtrl="ngModel">
                <div class="error-message" *ngIf="lastNameCtrl.invalid && lastNameCtrl.touched">
                    Last name is required and must be valid.
                </div>
            </div>
            <div class="form-field">
                <label for="emailId">Email</label>
                <input id="emailId" [(ngModel)]="model.Email" name="email" required email #emailCtrl="ngModel">
                <div class="error-message" *ngIf="emailCtrl.invalid && emailCtrl.touched">
                    Email is required and must be valid.
                </div>
            </div>
            <div class="form-field">
                <label for="passwordId">Password</label>
                <input id="passwordId" [(ngModel)]="model.Password" name="password" type="password" required #passCtrl="ngModel">
                <div class="error-message" *ngIf="passCtrl.invalid && passCtrl.touched">
                    Password is required.
                </div>
                <div class="error-message" *ngFor="let err of validatePassword(model.Password)">
                    {{ err }}
                </div>
            </div>
            <div class="form-field">
                <label for="passwordCheckId">Repeat password</label>
                <input id="passwordCheckId" [(ngModel)]="model.ConfirmPassword" name="passwordCheck" type="password" required #passCheckCtrl="ngModel">
                <div class="error-message" *ngIf="passCheckCtrl.invalid && passCheckCtrl.touched">
                    Password check is required.
                </div>
                <div class="error-message" *ngIf="passCheckCtrl.touched && model.Password !== model.ConfirmPassword">
                    Passwords do not match
                </div>
            </div>
            <div class="form-field">
                <label>
                    <input type="checkbox" [(ngModel)]="model.AcceptTerms" name="acceptTerms" required #acceptTermsCtrl="ngModel" />
                    <span>
                        I accept the <a href="/terms" target="_blank">terms and conditions</a>
                    </span>
                </label>
                <div class="error-message" *ngIf="acceptTermsCtrl.invalid && acceptTermsCtrl.touched">
                    You must accept the terms and conditions to proceed.
                </div>
            </div>
            <div *ngIf="error$ | async as error" class="error-message-box">
                <i class="fa fa-exclamation-triangle"></i> {{ error }}
            </div>
            <div class="footer-bar">
                <a routerLink="/builder" class="btn btn-secondary"><i class="fa fa-caret-left"></i> Back</a>
                <button type="submit" class="btn right"><i class="fa fa-save"></i> Save &amp; Continue</button>
            </div>
        </form>

        <loader-component *ngIf="loading$ | async"></loader-component>
    </div>
</div>

